import React from "react";
import { Link } from "react-router-dom";

import { BlogURL, BaseURL } from "../../APIs/APIUrls";
import Pagination2 from "../common/Pagination2";

const BLOGS_CACHE_KEY = "AllBlogsforWeb";
const BLOGS_CACHE_TS_KEY = "AllBlogsforWeb_TimeStamp";
const BLOGS_CACHE_TTL_MS = 5 * 60 * 1000;

const formatDate = (value) => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

const parseStoredArray = (value) => {
  try {
    const parsed = JSON.parse(value || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};


export default function Blogs2({ itemsPerPage = 9, onHomePage = false }) {
  const [ItemsPerPage] = React.useState(itemsPerPage);
  const [page, setPage] = React.useState(1);
  const [blogposts, setBlogposts] = React.useState([]);

  // Call POST API: SelectAllBlogsforWeb and render grid from returned rows.
  React.useEffect(() => {
    let cacheClearTimer;

    const clearBlogsCache = () => {
      localStorage.removeItem(BLOGS_CACHE_KEY);
      localStorage.removeItem(BLOGS_CACHE_TS_KEY);
    };

    const scheduleCacheClear = (cachedAt) => {
      const expiresAt = cachedAt + BLOGS_CACHE_TTL_MS;
      const delay = Math.max(0, expiresAt - Date.now());

      if (cacheClearTimer) {
        clearTimeout(cacheClearTimer);
      }

      cacheClearTimer = setTimeout(() => {
        clearBlogsCache();
      }, delay);
    };

    const loadBlogs = async () => {
      try {
        const cachedRaw = localStorage.getItem(BLOGS_CACHE_KEY);
        const cachedTsRaw = localStorage.getItem(BLOGS_CACHE_TS_KEY);
        const cachedBlogs = parseStoredArray(cachedRaw);
        const cachedAt = Number(cachedTsRaw);
        const isCacheValid =
          cachedBlogs.length > 0 &&
          !Number.isNaN(cachedAt) &&
          Date.now() - cachedAt < BLOGS_CACHE_TTL_MS;

        if (isCacheValid) {
          setBlogposts(cachedBlogs);
          scheduleCacheClear(cachedAt);
          return;
        }

        clearBlogsCache();

        const response = await fetch(`${BlogURL}GetAllBlogsforWeb`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data.Message === "Success") {
          const rows = data?.data || data?.Data || [];
          setBlogposts(rows);

          const now = Date.now();
          localStorage.setItem(BLOGS_CACHE_KEY, JSON.stringify(rows));
          localStorage.setItem(BLOGS_CACHE_TS_KEY, String(now));
          scheduleCacheClear(now);
        }
      } catch (error) {
        console.error("SelectAllBlogsforWeb error:", error);
      }
    };

    loadBlogs();

    return () => {
      if (cacheClearTimer) {
        clearTimeout(cacheClearTimer);
      }
    };
  }, []);

  return (
    <section className="flat-section">
      <div className="container">
        {
          onHomePage && (
            <div className="box-title text-center wow fadeInUp">
              <div className="text-subtitle text-primary">Latest Blogs</div>
              <h3 className="title mt-4">From Our Blog</h3>
            </div>
          )
        }

        <div className="row">
          {(onHomePage ? blogposts.slice(0, 3) : blogposts.slice((page - 1) * ItemsPerPage, page * ItemsPerPage)).map((post, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <Link
                to={`/blog-detail/${post.BlogId}-${post.URL}`}
                className="flat-blog-item hover-img"
              >
                <div className="img-style">
                  <img
                    className="lazyload"
                    data-src={post.CardImage}
                    alt={post.CardImageAltText}
                    src={BaseURL + post.CardImage}
                    width={615}
                    height={405}
                  />
                  <span className="date-post">{formatDate(post.CreatedOn)}</span>
                </div>
                <div className="content-box">
                  <div className="post-author">
                    <span className="fw-7">{post?._objAUserProfile?.Name}</span>
                    <span>Blog</span>
                  </div>
                  <h5 className="title link">{post.Title}</h5>
                  <p className="description">{post.ShortDescription}</p>
                </div>
              </Link>
            </div>
          ))}
          {onHomePage ? (
            <div className="col-12 text-center pt-26">
              <Link to="/blog-grid" className="tf-btn btn-view primary size-1 hover-btn-view">
                View More
              </Link>
            </div>
          ) : (
            <div className="col-12 text-center pt-26 line-t">
              <ul className="justify-content-center wd-navigation">
                <Pagination2 itemLength={blogposts.length} itemPerPage={ItemsPerPage} setPage={setPage} />
              </ul>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
